import {
  IP_ADDRESS_DATAS,
  LOADING_IP_ADDRESS_DATAS,
  LOADING_USER_TRACKING_DATAS,
  USER_TRACKING_DATAS,
} from '../constants/user_tracking';

const initialState = {
  ipAddressDatas: [],
  isLoadingIpAddressDatas: true,
  userTrackingDatas: [],
  isLoadingUserTrackingdatas: true,
};

export default function reducer(
  state = initialState,
  action = {
    type: '',
    // ipAddressDatas: [],
    // userTrackingDatas: [],
    payload: []
  }
) {
  // const { type, ipAddressDatas, userTrackingDatas } = action;
  const { type, payload } = action;
  switch (type) {
    case IP_ADDRESS_DATAS:
      return {
        ...state,
        ipAddressDatas: payload,
        isLoadingIpAddressDatas: false,
      };
    case LOADING_IP_ADDRESS_DATAS:
      return {
        ...state,
        isLoadingIpAddressDatas: true,
      };
    case USER_TRACKING_DATAS:
      return {
        ...state,
        userTrackingDatas: payload,
        isLoadingUserTrackingdatas: false,
      };
    case LOADING_USER_TRACKING_DATAS:
      return {
        ...state,
        isLoadingUserTrackingdatas: true,
      };
    default:
      return state;
  }
}